export default __webpack_public_path__ + "6b02c5da45d3dda16ff90ec41019ee8f.png";